
define('ldsh!modules/lp_info/templates/page_selector', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<ul class="ed-selectableList">\n  <li class="ed-loading">\n  <div class="ed-spinner"><i class="ed-icon ed-icon-marquee"></i></div>\n  <small class="ed-spinner-txt" data-i18n="landingPage.dialog.copyVariant.loading">cargando</small>\n  </li>\n</ul>\n';

}
return __p
};});

